import { jsx as _jsx } from "react/jsx-runtime";
import spinnerThirdIcon from '@/core/svg/fa/spinner-third.svg';
import tireIcon from '@/core/svg/fa/tire.svg';
import { useTheme } from '@mui/material';
import { SvgIconSpined } from './SpinnerSvgIcon.styled';
const SpinnerSvgIcon = ({ size = 'xl', color, variant = 'spinner' }) => {
    const theme = useTheme();
    return (_jsx(SvgIconSpined, { icon: variant === 'spinner' ? spinnerThirdIcon : tireIcon, size: size, color: color ?? theme.palette.primary.dark }));
};
export { SpinnerSvgIcon };
